@media (width >= 1024px) {
    .dialog {
        max-width: 552px;
        border-radius: var(--bi-radius-xl) var(--bi-radius-xl) var(--bi-scale-20x) var(--bi-radius-xl);
    }

    .dialogHeader {
        padding: var(--bi-scale-10x) var(--bi-scale-10x) var(--bi-scale-5x) var(--bi-scale-10x);
    }

    .dialogContent {
        padding: 0 var(--bi-scale-10x) var(--bi-scale-20x) var(--bi-scale-10x);
    }
}

.introText {
    color: var(--bi-neutral-60);
    font: var(--bi-font-body-large);
    margin-bottom: var(--bi-scale-8x);
}

.resultContent {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-6x);
    padding: var(--bi-scale-10x) var(--bi-scale-10x) var(--bi-scale-20x) var(--bi-scale-10x);
}

.resultMessage {
    font: var(--bi-font-title-bold-large);
}
